module.exports = Promise.all([__parcel__import__("lfHGD"), __parcel__import__("1IVx1")]).then(() => parcelRequire('gwx1L'));